import { render, staticRenderFns } from "./pushSwitch.vue?vue&type=template&id=339aa07e&scoped=true"
import script from "./pushSwitch.vue?vue&type=script&lang=js"
export * from "./pushSwitch.vue?vue&type=script&lang=js"
import style0 from "./pushSwitch.vue?vue&type=style&index=0&id=339aa07e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339aa07e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('339aa07e')) {
      api.createRecord('339aa07e', component.options)
    } else {
      api.reload('339aa07e', component.options)
    }
    module.hot.accept("./pushSwitch.vue?vue&type=template&id=339aa07e&scoped=true", function () {
      api.rerender('339aa07e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/pushSwitch.vue"
export default component.exports